/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthGetTokenRequest } from '../models/AuthGetTokenRequest';
import type { AuthGetTokenResponseApiRespoonse } from '../models/AuthGetTokenResponseApiRespoonse';
import type { AuthLoginRequest } from '../models/AuthLoginRequest';
import type { AuthLoginResponseApiRespoonse } from '../models/AuthLoginResponseApiRespoonse';
import type { AuthLogoutRequest } from '../models/AuthLogoutRequest';
import type { AuthLogoutResponseApiRespoonse } from '../models/AuthLogoutResponseApiRespoonse';
import type { AuthMeRequest } from '../models/AuthMeRequest';
import type { AuthMeResponseApiRespoonse } from '../models/AuthMeResponseApiRespoonse';
import type { AuthNoticeRequest } from '../models/AuthNoticeRequest';
import type { AuthNoticeResponseApiRespoonse } from '../models/AuthNoticeResponseApiRespoonse';
import type { AuthRefreshTokenRequest } from '../models/AuthRefreshTokenRequest';
import type { AuthRefreshTokenResponseApiRespoonse } from '../models/AuthRefreshTokenResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthService {

    /**
     * ログイン情報取得
     * この API を利用するには、ログイン済みである必要があります。
     * @param requestBody
     * @returns AuthMeResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static me(
        requestBody: AuthMeRequest,
    ): CancelablePromise<AuthMeResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/me',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Refresh token
     * @param requestBody
     * @returns AuthRefreshTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static refreshToken(
        requestBody: AuthRefreshTokenRequest,
    ): CancelablePromise<AuthRefreshTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/refresh-token',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Notice
     * @param requestBody
     * @returns AuthNoticeResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static notice(
        requestBody: AuthNoticeRequest,
    ): CancelablePromise<AuthNoticeResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notice',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get token
     * @param requestBody
     * @returns AuthGetTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static connectSocketUrl(
        requestBody: AuthGetTokenRequest,
    ): CancelablePromise<AuthGetTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/connect-socket-url',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ログイン
     * @param requestBody
     * @returns AuthLoginResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static login(
        requestBody: AuthLoginRequest,
    ): CancelablePromise<AuthLoginResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/login',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ログアウト
     * @param requestBody
     * @returns AuthLogoutResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static logout(
        requestBody: AuthLogoutRequest,
    ): CancelablePromise<AuthLogoutResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/logout',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
